var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMarkedcalendar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2767EB79-3DF5-4DF8-9FB5-20485D2616E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,20 L3,6 L19,6 L19,20 L3,20 Z M17,18 L17,8 L5,8 L5,18 L17,18 Z M6,17 L6,15 L16,15 L16,17 L6,17 Z M6,14 L6,12 L16,12 L16,14 L6,14 Z M14,11 L14,9 L16,9 L16,11 L14,11 Z M20,5 L7,5 L7,3 L22,3 L22,16 L20,16 L20,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Home",
    transform: "translate(-29.000000, -1163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOOTER",
    transform: "translate(0.000000, 1147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_markedcalendar",
    transform: "translate(26.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMarkedcalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_markedcalendar.71f6ace99a609cc244ba228b79ac3c59.svg";